module.exports = __webpack_public_path__ + "static/images/label_s.015f702.png";